export enum CurrencyEnum {
  USD = 'usd',
  EUR = 'eur',
}

export const DEFAULT_CURRENCY = CurrencyEnum.USD

export const getCurrencyForCountry = (countryIso: string): CurrencyEnum => {
  const europeanCountries = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'NO',
    'IS',
    'LI',
    'CH',
    'RS',
    'BA',
    'ME',
    'MK',
    'AL',
    'MD',
    'UA',
    'BY',
    'TR',
    'GE',
    'AM',
    'AZ',
    'AD',
    'MC',
    'SM',
    'VA',
  ]
  if (europeanCountries.includes(countryIso)) {
    return CurrencyEnum.EUR
  }
  return DEFAULT_CURRENCY
}
